import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cta from "../components/Cta";
import { client } from "../config/prismic";

const SpecialSession = () => {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("special_session");
      setSessions(response.results.map((result) => result.data));
    };
    fetchData();
  }, []);

  if (!sessions) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  console.log(sessions); // Debugging the structure

  return (
    <div>
      <Header page={true} />
      <Cta title="Special Sessions" />
      <div className="container my-12 md:my-20 py-3">
        {sessions?.map((session, sessionIndex) => (
          <div key={sessionIndex} className="mb-4">
            {/* Session Title */}
            <h2 className="fw-bold text-center mb-4 text-pink">
              {session?.title?.[0]?.text}
            </h2>

            <div className="d-flex flex-row justify-content-center flex-wrap">
              {session?.speakers?.map((speaker, speakerIndex) => (
                <div className="col-md-3 text-center p-3" key={speakerIndex}>
                  <div className="border-0">
                    <img
                      src={speaker?.image?.url}
                      alt={speaker?.name?.[0]?.text}
                      className="card-img-top img-fluid"
                      style={{ maxHeight: "300px", objectFit: "cover" }}
                    />
                    <div className="mt-2">
                      <h4 className="mb-2 font-weight-bold">
                        {speaker?.name?.[0]?.text}
                      </h4>
                      <p className="card-text">
                        {speaker?.designation?.[0]?.text ?? ""}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default SpecialSession;
